var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewRegistration({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.7294 12.747C2.02113 11.8269 1.66699 11.3668 1.66699 10.0007C1.66699 8.6345 2.02113 8.17442 2.7294 7.25426C4.14363 5.41695 6.51542 3.33398 10.0003 3.33398C13.4852 3.33398 15.857 5.41695 17.2712 7.25426C17.9795 8.17442 18.3337 8.6345 18.3337 10.0007C18.3337 11.3668 17.9795 11.8269 17.2712 12.747C15.857 14.5844 13.4852 16.6673 10.0003 16.6673C6.51542 16.6673 4.14363 14.5844 2.7294 12.747Z",
    stroke: "#2058E7",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 10C12.5 11.3807 11.3807 12.5 10 12.5C8.61929 12.5 7.5 11.3807 7.5 10C7.5 8.61929 8.61929 7.5 10 7.5C11.3807 7.5 12.5 8.61929 12.5 10Z",
    stroke: "#2058E7",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewRegistration);
export default __webpack_public_path__ + "static/media/NewRegistration.93cb8bc28ffad0f105390912d47277ec.svg";
export { ForwardRef as ReactComponent };